import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export interface CalculateLTLFreightClassRequest {
  externalCustomerId: number;
  qty: number;
  dimensions: {
    length: number;
    width: number;
    height: number;
    units: string;
  };
  weight: {
    weight: number;
    unit: string;
  };
}

export interface CalculateLTLFreightClassResponse {
  id: number;
  value: string;
  key: string;
}

const LTL_FREIGHT_CLASS_CALCULATE_PATH = '/quote/ltl/freight-class/calculate';

export async function calculateLTLFreightClass(
  request: CalculateLTLFreightClassRequest
): Promise<Result<CalculateLTLFreightClassResponse, ApiError>> {
  try {
    const response = await axios.put<CalculateLTLFreightClassResponse>(
      LTL_FREIGHT_CLASS_CALCULATE_PATH,
      request
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'calculateLTLFreightClass' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to calculate LTL freight class' });
    }

    return err({
      message:
        typeof error.response?.data === 'string'
          ? error.response.data
          : (error.response?.data?.message ??
            'Failed to calculate LTL freight class'),
      status: error.response?.status,
    });
  }
}
